import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '../store/index';

const Login = () =>
  import(/* webpackChunkName: "basic" */ '@/views/Auth/Login.vue');
const ResetPassword = () =>
  import(/* webpackChunkName: "basic" */ '@/views/Auth/ResetPassword.vue');
const Home = () => import(/* webpackChunkName: "basic" */ '@/views/Home.vue');

const Dashboard = () =>
  import(/* webpackChunkName: "sidebar" */ '@/views/Dashboard.vue');
const Campaigns = () =>
  import(/* webpackChunkName: "sidebar" */ '@/views/Campaigns.vue');
const KIWIndex = () =>
  import(/* webpackChunkName: "sidebar" */ '@/views/KIW/Index.vue');
const KiwSingle = () =>
  import(/* webpackChunkName: "sidebar" */ '@/views/KIW/Single.vue');
const KiwEdit = () =>
  import(/* webpackChunkName: "sidebar" */ '@/views/KIW/Edit.vue');
const Help = () => import(/* webpackChunkName: "sidebar" */ '@/views/Help.vue');

const ChatIndex = () =>
  import(/* webpackChunkName: "features" */ '@/views/Chat/Index.vue');
const ChatSingle = () =>
  import(/* webpackChunkName: "features" */ '@/views/Chat/Single.vue');
const Notifications = () =>
  import(/* webpackChunkName: "features" */ '@/views/Notifications.vue');
const UserSettings = () =>
  import(
    /* webpackChunkName: "features" */ '@/views/Settings/UserSettings.vue'
  );
const AdminSettings = () =>
  import(
    /* webpackChunkName: "features" */ '@/views/Settings/AdminSettings.vue'
  );
const Tags = () =>
  import(/* webpackChunkName: "features" */ '@/views/Tags.vue');
const ReplacementsCalendar = () =>
  import(/* webpackChunkName: "features" */ '@/views/ReplacementsCalendar.vue');

const ProjectsIndex = () =>
  import(/* webpackChunkName: "project" */ '@/views/Projects/Index.vue');
const ProjectSingle = () =>
  import(/* webpackChunkName: "project" */ '@/views/Projects/Single.vue');
const ProjectEdit = () =>
  import(/* webpackChunkName: "project" */ '@/views/Projects/Edit.vue');
const ProjectChanges = () =>
  import(
    /* webpackChunkName: "project" */ '@/views/Projects/ProjectChanges.vue'
  );
const ProjectMetrics = () =>
  import(
    /* webpackChunkName: "project" */ '@/views/Projects/ProjectMetrics.vue'
  );
const RequiredActionProjects = () =>
  import(
    /* webpackChunkName: "project" */ '@/views/Projects/RequiredActionProjects.vue'
  );
const ProjectsArchive = () =>
  import(/* webpackChunkName: "project" */ '@/views/Projects/Archive.vue');
const ProjectsArchiveSingle = () =>
  import(
    /* webpackChunkName: "project" */ '@/views/Projects/SingleArchive.vue'
  );
const QuickAcceptance = () =>
  import(
    /* webpackChunkName: "project" */ '@/views/Projects/QuickAcceptance.vue'
  );
const Trash = () =>
  import(/* webpackChunkName: "project" */ '@/views/Projects/Trash.vue');

const CreateProject = () =>
  import(/* webpackChunkName: "create" */ '@/views/Projects/CreateProject.vue');
const CreateKIW = () =>
  import(/* webpackChunkName: "create" */ '@/views/KIW/Create.vue');
const CreateCommercialPrint = () =>
  import(/* webpackChunkName: "create" */ '@/views/CommercialPrint/Create.vue');
const CommercialPrintIndex = () =>
  import(/* webpackChunkName: "create" */ '@/views/CommercialPrint/Index.vue');
const CommercialPrintSingle = () =>
  import(/* webpackChunkName: "create" */ '@/views/CommercialPrint/Single.vue');
const CommercialPrintChanges = () =>
  import(
    /* webpackChunkName: "create" */ '@/views/CommercialPrint/CommercialPrintChanges.vue'
  );
const CommercialPrintEdit = () =>
  import(/* webpackChunkName: "create" */ '@/views/CommercialPrint/Edit.vue');
const DkoCooperationIndex = () =>
  import(/* webpackChunkName: "dko" */ '@/views/DkoCooperation/Index.vue');
const DkoCooperationSingle = () =>
  import(/* webpackChunkName: "dko" */ '@/views/DkoCooperation/Single.vue');
const DkoCooperationCreate = () =>
  import(/* webpackChunkName: "dko" */ '@/views/DkoCooperation/Create.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { public: true },
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: ResetPassword,
    meta: { public: true },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      roles: [
        'admin_director',
        'chief',
        'user_admin',
        'department_director',
        'user',
        'graphic',
        'editor',
        'project_manager',
        'print_coordinator',
        'guard',
        'other',
      ],
    },
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          roles: ['admin_director', 'chief', 'department_director'],
        },
      },
      {
        path: '/campaigns',
        name: 'campaigns',
        component: Campaigns,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
      },
      {
        path: '/projects',
        name: 'projects-index',
        component: ProjectsIndex,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
      },
      {
        path: '/projects-with-action',
        name: 'required-action-projects',
        component: RequiredActionProjects,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
      },
      {
        path: '/my-projects',
        name: 'my-projects',
        component: ProjectsIndex,
        props: { ownProjects: true },
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
      },
      {
        path: '/quick-acceptance',
        name: 'quick-acceptance',
        component: QuickAcceptance,
        meta: {
          roles: ['admin_director', 'chief', 'department_director'],
        },
      },
      {
        path: '/trash',
        name: 'trash',
        component: Trash,
        meta: {
          roles: ['admin_director', 'chief', 'department_director'],
        },
      },
      {
        path: '/project/:id',
        name: 'project-single',
        props: true,
        component: ProjectSingle,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
      },
      {
        path: '/project/:id/edit',
        name: 'project-edit',
        props: true,
        component: ProjectEdit,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
          ],
        },
      },
      {
        path: '/commercial-print/:id/edit',
        name: 'commercial-print-edit',
        props: true,
        component: CommercialPrintEdit,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
          ],
        },
      },
      {
        path: '/project/:id/changes',
        name: 'project-changes',
        props: true,
        component: ProjectChanges,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'other',
          ],
        },
      },
      {
        path: '/commercial-print/:id/changes',
        name: 'commercial-print-changes',
        props: true,
        component: CommercialPrintChanges,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'other',
          ],
        },
      },
      {
        path: '/project/:id/metrics',
        name: 'project-metrics',
        props: true,
        component: ProjectMetrics,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'other',
          ],
        },
      },
      {
        path: '/project/:projectId/chat',
        name: 'project-chat',
        props: true,
        component: ChatIndex,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'other',
            'guard',
          ],
        },
        children: [
          {
            path: ':channelId',
            name: 'project-chat-channel',
            props: true,
            component: ChatSingle,
            meta: {
              roles: [
                'admin_director',
                'chief',
                'department_director',
                'user',
                'graphic',
                'editor',
                'project_manager',
                'print_coordinator',
                'other',
                'guard',
              ],
            },
          },
        ],
      },
      {
        path: '/archive/projects',
        name: 'archive-projects',
        component: ProjectsArchive,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/archive/project/:id',
        name: 'archive-project-single',
        props: true,
        component: ProjectsArchiveSingle,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/archive/project/:id/kiw',
        name: 'archive-project-create-kiw',
        props: (route) => ({
          id: parseInt(route.params.id, 10),
          fromArchive: true,
        }),
        component: CreateKIW,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/kiw',
        name: 'kiw-index',
        props: true,
        component: KIWIndex,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/commercial-print',
        name: 'commercial-print-index',
        props: true,
        component: CommercialPrintIndex,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/dko-cooperation',
        name: 'dko-cooperation-index',
        component: DkoCooperationIndex,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/dko-cooperation/:id',
        name: 'dko-cooperation-single',
        props: true,
        component: DkoCooperationSingle,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/kiw/:id',
        name: 'kiw-single',
        props: true,
        component: KiwSingle,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/commercial-print/:id',
        name: 'commercial-print-single',
        props: true,
        component: CommercialPrintSingle,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/edit/:id/kiw',
        name: 'kiw-edit',
        props: true,
        component: KiwEdit,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/create/kiw',
        name: 'create-kiw',
        component: CreateKIW,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/create/project',
        name: 'create-project',
        component: CreateProject,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
          ],
        },
      },
      {
        path: '/create/dko',
        name: 'create-dko',
        component: DkoCooperationCreate,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
          ],
        },
      },
      {
        path: '/create/commercial-print',
        name: 'create-commercial-print',
        component: CreateCommercialPrint,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/help',
        name: 'help',
        component: Help,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'user_admin',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/users',
        name: 'admin-settings',
        component: AdminSettings,
        meta: {
          roles: ['admin_director', 'chief', 'user_admin'],
        },
      },
      {
        path: '/tags',
        name: 'tags',
        component: Tags,
        meta: {
          roles: ['admin_director', 'chief', 'user_admin'],
        },
      },
      {
        path: '/chat',
        name: 'chat-index',
        component: ChatIndex,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
        children: [
          {
            path: ':channelId',
            name: 'chat-channel',
            props: true,
            component: ChatSingle,
            meta: {
              roles: [
                'admin_director',
                'chief',
                'department_director',
                'user',
                'graphic',
                'editor',
                'project_manager',
                'print_coordinator',
                'guard',
              ],
            },
          },
        ],
      },
      {
        path: '/notifications',
        name: 'notifications',
        component: Notifications,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
          ],
        },
      },
      {
        path: '/settings',
        name: 'user-settings',
        component: UserSettings,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'user_admin',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '/replacements',
        name: 'replacements-calendar',
        component: ReplacementsCalendar,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'user_admin',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
      {
        path: '*',
        name: 'not-found',
        component: ProjectsIndex,
        meta: {
          roles: [
            'admin_director',
            'chief',
            'user_admin',
            'department_director',
            'user',
            'graphic',
            'editor',
            'project_manager',
            'print_coordinator',
            'guard',
            'other',
          ],
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (
    store.getters['auth/isLoggedIn'] &&
    (to.path === '/' || to.path === '/login')
  ) {
    let baseRedirectDestination = 'projects-index';
    if (store.getters['auth/checkUserPermissions'](['other'])) {
      baseRedirectDestination = 'archive-projects';
    }
    next({ name: baseRedirectDestination });
  } else if (
    store.getters['auth/isLoggedIn'] &&
    store.getters['auth/checkUserPermissions'](to.meta.roles)
  ) {
    next();
  } else if (store.getters['auth/isLoggedIn']) {
    next({ path: '/' });
  } else if (to.matched.some((record) => record.meta.public)) {
    next();
  } else {
    store.dispatch('auth/changeDestinationPath', to.path);
    next({ name: 'login' });
  }
});

export default router;
